import papermachines from "../images/papermachines.jpg";
import industrial from "../images/industrial.jpg";
import pulper from "../images/pulper.jpg";
import pulpthickener from "../images/pulpthick.jpg";
import agitator from "../images/chest.webp";
import separator from "../images/turbo.webp";
import rewinder from "../images/rewinder.jpg";
import rfFormer from "../images/RF Former.webp";
import twinWire from "../images/twinwire.jpg";
import dryer from "../images/dryer.webp";
import jumboPress from "../images/jumbopress.png";
import rotaryKiln from "../images/rotaryklin.jpg";
import ballMill from "../images/ballmill.jpg";
import rotaryCooler from "../images/rotarycooler.jpg";
export const categories = [
  {
    id: "paper",
    title: "Paper Machines",
    image: papermachines,
    machineIds: ["pulper", "thickener", "agitator", "separator", "rewinder", "rf-former", "twin-wire", "dryer", "jumbo-press",],
  },
  {
    id: "industrial-machines",
    title: "Industrial Machinery",
    image: industrial,
    machineIds: ["rotary-kiln", "ball-mill", "rotary-cooler"],
  },
];

export const machines = {
  pulper: {
    id: "pulper",
    title: "Low/Medium Consistency Pulper",
    image: pulper,
    desc: "Continuous or batch pulper for 3–5% consistency; sizes from 3 m³ to 24 m³.",
    specs: ["Capacity: 3–24 m³", "Consistency: 3–5%", "Optional belt conveyor 650–1800 mm"],
  },
  thickener: {
    id: "thickener",
    title: "Pulp Thickener (Drum/Vat)",
    image: pulpthickener,
    desc: "Reliable dewatering for Kraft/Board production.",
    specs: ["Widths: 2–6 m", "Drum Ø: 1.2–1.8 m", "Materials: MS/SS, CI/SS"],
  },
  agitator: {
    id: "agitator",
    title: "Chest Agitator",
    image: agitator,
    desc: "Efficient mixing for 40–150 m³ chests.",
    specs: ["Material: SS304", "Draw-out design for easy service"],
  },
  separator: {
    id: "separator",
    title: "Turbo Separator",
    image: separator,
    desc: "Reject separation for high-quality pulp.",
    specs: ["Capacity: 1.5–15 TPH", "Material: SS304"],
  },
  rewinder: {
    id: "rewinder",
    title: "Rewinder",
    image: rewinder,
    desc: "Heavy-duty rewinder for board, kraft, and writing paper.",
    specs: ["Speed: up to 1200 m/min", "Features: pneumatic rider, reel push roll"],
  },

  // Board Machines
  "rf-former": {
    id: "rf-former",
    title: "Rectifier Former",
    image: rfFormer,
    desc: "For uniform sheet formation in board machines.",
    specs: ["Suitable for board grades", "High drainage efficiency"],
  },
  "twin-wire": {
    id: "twin-wire",
    title: "Twin Wire Former",
    image: twinWire,
    desc: "Twin-wire forming section for high-speed board production.",
    specs: ["High speed", "Improved sheet strength"],
  },
  dryer: {
    id: "dryer",
    title: "Dryer Section",
    image: dryer,
    desc: "Drying cylinders for moisture removal in paper/board.",
    specs: ["Steam heated cylinders", "Hood with heat recovery"],
  },

  // Writing & Printing
  "jumbo-press": {
    id: "jumbo-press",
    title: "Jumbo Press",
    image: jumboPress,
    desc: "High capacity press section for writing/printing machines.",
    specs: ["High nip pressure", "Large roll diameter"],
  },

  // Non-Paper Industrial Machinery
  "rotary-kiln": {
    id: "rotary-kiln",
    title: "Rotary Kiln",
    image: rotaryKiln,
    desc: "Rotary kiln for calcination in cement, lime, and other industries.",
    specs: ["Variable size options", "Robust refractory lining"],
  },
  "ball-mill": {
    id: "ball-mill",
    title: "Ball Mill",
    image: ballMill,
    desc: "Grinding machine for minerals and industrial use.",
    specs: ["Capacity: customizable", "Steel/ceramic liners"],
  },
  "rotary-cooler": {
    id: "rotary-cooler",
    title: "Rotary Cooler",
    image: rotaryCooler,
    desc: "Used for cooling clinker and other bulk materials.",
    specs: ["High thermal efficiency", "Durable design"],
  },
};
